import { SET_SELECTED_ORDER_PAYMENT_METHOD } from './OrderActionTypes';
import type { IPaymentMethodView } from '@model/PaymentMethod.model';

export const setSelectedPaymentMethodAction =
  (method: IPaymentMethodView | null) => (dispatch: any) => {
    dispatch({
      type: SET_SELECTED_ORDER_PAYMENT_METHOD,
      payload: { method: method ?? null },
    });
  };
